import { render, staticRenderFns } from "./RefreshPDF.vue?vue&type=template&id=3f16353e&"
import script from "./RefreshPDF.vue?vue&type=script&lang=js&"
export * from "./RefreshPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports